import { createMuiTheme } from '@material-ui/core/styles'

import { getFont, getLanguage } from '../localization'

const container = document.getElementById('adlSearchboxContainer')
export const color = container?.getAttribute('color')
export const hoverColor = container?.getAttribute('hover-color')
export const calendarColor = container?.getAttribute('calendar-color') || '#666'

export const palette = {
  primary: {
    main: color ?? '#BF0A30',
    light: '#F4D6DC',
    dark: hoverColor ?? '#600518',
    contrastText: '#ffffff'
  },
  secondary: {
    main: '#0ABF99',
    light: '#6CF7DA',
    dark: '#05604D',
    contrastText: '#ffffff'
  },
  grey: {
    100: '#F9FAFB',
    200: '#F4F6F8',
    300: '#DDE1E6',
    400: '#C4CDD5',
    500: '#919EAB',
    600: '#637381',
    700: '#454F5B',
    800: '#212B36',
    900: '#161C24'
  },
  background: {
    default: '#fff',
    paper: '#F8F8F8'
  },
  error: {
    light: '#FAE0DF',
    main: '#FF4842',
    dark: '#C90600',
    contrastText: '#ffffff'
  },
  warning: {
    light: '#FFD864',
    main: '#FFC107',
    dark: '#A47B00'
  },
  info: {
    light: '#8CC8FF',
    main: '#1890FF',
    dark: '#005BAE',
    contrastText: calendarColor ? calendarColor : color ? color : '#BF0A30'
  },
  success: {
    light: '#97EB8A',
    main: '#3AC922',
    dark: '#247E15'
  },
  text: {
    primary: '#212B36',
    secondary: '#454F5B',
    disabled: '#919EAB'
  }
}

const Theme = createMuiTheme({
  direction: getLanguage() === 'fa' ? 'rtl' : 'ltr',
  palette: palette,
  spacing: 8,
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 10000,
    snackbar: 11000,
    tooltip: 12000
  },
  typography: {
    fontFamily: getFont(),
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    fontSize: 16,
    h6: {
      fontSize: 12,
      color: palette.text.secondary,
      lineHeight: '15px',
      fontWeight: 500
    },
    h5: {
      fontSize: 14,
      fontWeight: 500,
      color: palette.text.secondary
    },
    h4: {
      fontSize: 16,
      fontWeight: 600,
      color: palette.text.secondary
    },
    h3: {
      fontSize: 24,
      fontWeight: 600,
      color: palette.text.secondary
    },
    h2: {
      fontSize: 28,
      color: palette.text.primary,
      fontWeight: 600
    },
    h1: {
      fontSize: 35,
      fontWeight: 600,
      color: palette.text.primary
    },
    body1: {
      fontSize: 16,
      fontWeight: 600,
      color: palette.text.secondary
    },
    subtitle1: {
      fontSize: 18,
      fontWeight: 600,
      color: palette.text.secondary
    },
    subtitle2: {
      fontSize: 16,
      fontWeight: 600,
      color: palette.text.secondary
    },
    button: {
      fontSize: 12,
      textTransform: 'none'
    }
  }
})

export default Theme
